import { API_URLS } from "../Constants/api.constants";
import api from "./api";

import { errorHandling } from "./error.handling";

const reportBasePath = API_URLS.REPORTS;
const logBasePath = API_URLS.LOG;
const protocolsBasePath = API_URLS.VEHICLE_V3;

const normalizeTypeReportForApi = (fileType) =>
  `${fileType || ""}`.toLowerCase() === "xlsx" ? "xls" : fileType;

const normalizeReportPayloadForApi = (payload = {}) => {
  const normalizedPayload = { ...payload };

  if (Object.prototype.hasOwnProperty.call(normalizedPayload, "TypeReport")) {
    normalizedPayload.TypeReport = normalizeTypeReportForApi(
      normalizedPayload.TypeReport,
    );
  }

  if (Object.prototype.hasOwnProperty.call(normalizedPayload, "typeReport")) {
    normalizedPayload.typeReport = normalizeTypeReportForApi(
      normalizedPayload.typeReport,
    );
  }

  if (Object.prototype.hasOwnProperty.call(normalizedPayload, "fileType")) {
    normalizedPayload.fileType = normalizeTypeReportForApi(
      normalizedPayload.fileType,
    );
  }

  return normalizedPayload;
};

async function fetchJourneyWork(payload, download) {
  try {
    const queryString = new URLSearchParams();
    if (
      payload?.vehicleId !== undefined &&
      payload?.vehicleId !== null &&
      Number(payload.vehicleId) > 0
    ) {
      queryString.append("VehicleId", payload.vehicleId);
    }
    if (payload?.dateTimeScheduleStart) {
      const startDate = payload.dateTimeScheduleStart.split("T")[0];
      queryString.append("startdate", startDate);
    }
    if (payload?.dateTimeScheduleEnd) {
      const endDate = payload.dateTimeScheduleEnd.split("T")[0];
      queryString.append("enddate", endDate);
    }
    if (
      payload?.driverId !== undefined &&
      payload?.driverId !== null &&
      Number(payload.driverId) > 0
    ) {
      queryString.append("DriverId", payload.driverId);
    }
    queryString.append("Extra", "N");
    const normalizedFileType = normalizeTypeReportForApi(payload?.fileType);

    const endpoint = download
      ? normalizedFileType === "pdf"
        ? `${reportBasePath}/vehicle-summary-segments/pdf`
        : normalizedFileType === "xls"
          ? `${reportBasePath}/vehicle-summary-segments/xls`
          : `${reportBasePath}/vehicle-summary-segments`
      : `${reportBasePath}/vehicle-summary-segments`;

    const query = queryString.toString();

    const response = await api.get(
      `${endpoint}${query ? `?${query}` : ""}`,
      download ? { responseType: "blob" } : undefined,
    );

    console.log("JourneyWorkReport", response);

    let treated = errorHandling.handleResponse(
      response,
      "reportService.fetchJourneyWork",
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "reportService.fetchJourneyWork");
    return null;
  }
}

async function fetchDistanceTravelled(payload, download) {
  try {
    const queryString = new URLSearchParams();
    if (payload?.vehicleId !== undefined && payload?.vehicleId !== null) {
      queryString.append("VehicleId", payload.vehicleId);
    }
    if (payload?.dateTimeScheduleStart) {
      queryString.append("startDate", payload.dateTimeScheduleStart);
    }
    if (payload?.dateTimeScheduleEnd) {
      queryString.append("EndDate", payload.dateTimeScheduleEnd);
    }

    const query = queryString.toString();

    let endpoint;
    let isFileDownload = false;
    if (download && payload?.fileType) {
      const normalizedFileType = normalizeTypeReportForApi(payload.fileType);
      isFileDownload =
        normalizedFileType === "pdf" || normalizedFileType === "xls";
      endpoint =
        normalizedFileType === "pdf"
          ? `${reportBasePath}/distance-traveled/pdf`
          : normalizedFileType === "xls"
            ? `${reportBasePath}/distance-traveled/xls`
            : `${reportBasePath}/distance-traveled`;
    } else {
      endpoint = `${reportBasePath}/distance-traveled`;
    }

    const response = await api.get(
      `${endpoint}${query ? `?${query}` : ""}`,
      isFileDownload ? { responseType: "blob" } : undefined,
    );

    console.log("DistanceTraveledReport", response);

    if (isFileDownload) {
      return response?.data ?? null;
    }

    let treated = errorHandling.handleResponse(
      response,
      "reportService.fetchDistanceTravelled",
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "reportService.fetchDistanceTravelled");
    return null;
  }
}

async function fetchVehicleActivities(payload, download) {
  try {
    const queryString = new URLSearchParams();
    if (payload?.vehicleId !== undefined && payload?.vehicleId !== null) {
      queryString.append("VehicleId", payload.vehicleId);
    }
    if (payload?.dateTimeScheduleStart) {
      queryString.append("StartDate", payload.dateTimeScheduleStart);
    }
    if (payload?.dateTimeScheduleEnd) {
      queryString.append("EndDate", payload.dateTimeScheduleEnd);
    }
    if (payload?.speed !== undefined && payload?.speed !== null) {
      queryString.append("Speed", payload.speed);
    }
    queryString.append("RegionalId", payload?.regionalId ?? 0);
    queryString.append("GroupId", payload?.groupId ?? 0);

    const query = queryString.toString();

    let endpoint;
    let isFileDownload = false;
    if (download && payload?.fileType) {
      const normalizedFileType = normalizeTypeReportForApi(payload.fileType);
      isFileDownload =
        normalizedFileType === "pdf" || normalizedFileType === "xls";
      endpoint =
        normalizedFileType === "pdf"
          ? `${reportBasePath}/vehicle-summary-activity/pdf`
          : normalizedFileType === "xls"
            ? `${reportBasePath}/vehicle-summary-activity/xls`
            : `${reportBasePath}/vehicle-summary-activity`;
    } else {
      endpoint = `${reportBasePath}/vehicle-summary-activity`;
    }

    const response = await api.get(
      `${endpoint}${query ? `?${query}` : ""}`,
      isFileDownload ? { responseType: "blob" } : undefined,
    );

    console.log("VehicleActivitiesReport", response);

    if (isFileDownload) {
      return response?.data ?? null;
    }

    let treated = errorHandling.handleResponse(
      response,
      "reportService.fetchVehicleActivities",
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "reportService.fetchVehicleActivities");
    return null;
  }
}

async function fetchVehiclePositions(payload, download) {
  try {
    const response = await api.get(
      (() => {
        if (!download) {
          const screenQuery = new URLSearchParams();

          if (payload?.vehicleId !== undefined && payload?.vehicleId !== null) {
            screenQuery.append("VehicleId", payload.vehicleId);
          }
          if (payload?.dateTimeScheduleStart) {
            screenQuery.append("StartDate", payload.dateTimeScheduleStart);
          }
          if (payload?.dateTimeScheduleEnd) {
            screenQuery.append("EndDate", payload.dateTimeScheduleEnd);
          }

          screenQuery.append("OnlyEvents", "N");
          screenQuery.append("GroupId", `${payload?.groupId ?? 0}`);

          return `${reportBasePath}/vehicle-positions/positions?${screenQuery.toString()}`;
        }

        const downloadQuery = new URLSearchParams();
        if (payload?.vehicleId !== undefined && payload?.vehicleId !== null) {
          downloadQuery.append("VehicleId", payload.vehicleId);
        }
        if (payload?.dateTimeScheduleStart) {
          downloadQuery.append("StartDate", payload.dateTimeScheduleStart);
        }
        if (payload?.dateTimeScheduleEnd) {
          downloadQuery.append("EndDate", payload.dateTimeScheduleEnd);
        }
        if (payload?.fileType) {
          downloadQuery.append(
            "TypeReport",
            normalizeTypeReportForApi(payload.fileType),
          );
        }

        return `${reportBasePath}/vehicle-positions/positions?${downloadQuery.toString()}`;
      })(),
    );

    console.log("VehicleActivitiesReport", response);

    let treated = errorHandling.handleResponse(
      response,
      "reportService.fetchVehicleActivities",
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "reportService.fetchVehicleActivities");
    return null;
  }
}

async function fetchVisitsInPeriod(payload, download) {
  try {
    const normalizedEventType = `${payload?.eventType ?? "2"}`.trim();
    const shouldIncludeEventType = normalizedEventType !== "";

    if (download) {
      const queryString = new URLSearchParams();
      const normalizedFileType = normalizeTypeReportForApi(payload?.fileType);

      queryString.append("GroupId", payload.groupId);
      queryString.append("VehicleId", payload.vehicleId);
      if (normalizedFileType === "pdf") {
        const endpoint = `${reportBasePath}/vehicle-visit-summaries/pdf`;
        const query = [
          `GroupId=${payload.groupId}`,
          `VehicleId=${payload.vehicleId}`,
          ...(payload?.dateTimeScheduleStart
            ? [`StartDate=${payload.dateTimeScheduleStart}`]
            : []),
          ...(payload?.dateTimeScheduleEnd
            ? [`EndDate=${payload.dateTimeScheduleEnd}`]
            : []),
          `Duration=${payload.durationTime}`,
          ...(shouldIncludeEventType
            ? [`EventType=${normalizedEventType}`]
            : []),
        ].join("&");

        const response = await api.get(`${endpoint}?${query}`, {
          responseType: "blob",
          headers: {
            Accept: "application/pdf",
          },
        });

        console.log("VisitsInPeriodReport", response);
        return response?.data ?? null;
      }

      if (normalizedFileType === "xls") {
        const endpoint = `${reportBasePath}/vehicle-visit-summaries/xls`;
        const query = [
          `GroupId=${payload.groupId}`,
          `VehicleId=${payload.vehicleId}`,
          ...(payload?.dateTimeScheduleStart
            ? [`StartDate=${payload.dateTimeScheduleStart}`]
            : []),
          ...(payload?.dateTimeScheduleEnd
            ? [`EndDate=${payload.dateTimeScheduleEnd}`]
            : []),
          `Duration=${payload.durationTime}`,
          ...(shouldIncludeEventType
            ? [`EventType=${normalizedEventType}`]
            : []),
        ].join("&");

        const response = await api.get(`${endpoint}?${query}`, {
          responseType: "blob",
          headers: {
            Accept: "application/vnd.ms-excel",
          },
        });

        console.log("VisitsInPeriodReport", response);

        return response?.data ?? null;
      }

      if (payload?.dateTimeScheduleStart) {
        queryString.append("StartDate", payload.dateTimeScheduleStart);
      }
      if (payload?.dateTimeScheduleEnd) {
        queryString.append("EndDate", payload.dateTimeScheduleEnd);
      }
      if (payload?.fileType) {
        queryString.append("TypeReport", normalizedFileType);
      }
      if (shouldIncludeEventType) {
        queryString.append("EventType", normalizedEventType);
      }

      const endpoint = `${reportBasePath}/vehicle-visit-summaries`;

      const response = await api.get(
        `${endpoint}?${queryString}&DurationTime=${payload.durationTime}`,
      );

      console.log("VisitsInPeriodReport", response);

      let treated = errorHandling.handleResponse(
        response,
        "reportService.fetchVisitsInPeriod",
      );
      if (treated) {
        return treated;
      }
      return null;
    }

    const queryString = new URLSearchParams();
    queryString.append("GroupId", payload.groupId);
    queryString.append("VehicleId", payload.vehicleId);
    if (payload?.dateTimeScheduleStart) {
      queryString.append("StartDate", payload.dateTimeScheduleStart);
    }
    if (payload?.dateTimeScheduleEnd) {
      queryString.append("EndDate", payload.dateTimeScheduleEnd);
    }
    if (shouldIncludeEventType) {
      queryString.append("EventType", normalizedEventType);
    }

    const endpoint = `${reportBasePath}/vehicle-visit-summaries`;

    const response = await api.get(`${endpoint}?${queryString.toString()}`);

    console.log("VisitsInPeriodReport", response);

    let treated = errorHandling.handleResponse(
      response,
      "reportService.fetchVisitsInPeriod",
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "reportService.fetchVisitsInPeriod");
    return null;
  }
}

async function fetchVisitsAmount(payload, download) {
  try {
    const queryString = new URLSearchParams();
    if (payload?.groupId !== undefined && payload?.groupId !== null) {
      queryString.append("GroupId", payload.groupId);
    }
    if (payload?.vehicleId !== undefined && payload?.vehicleId !== null) {
      queryString.append("VehicleId", payload.vehicleId);
    }
    if (payload?.dateTimeScheduleStart) {
      queryString.append("StartDate", payload.dateTimeScheduleStart);
    }
    if (payload?.dateTimeScheduleEnd) {
      queryString.append("EndDate", payload.dateTimeScheduleEnd);
    }
    if (payload?.eventType !== undefined && payload?.eventType !== null) {
      queryString.append("EventType", payload.eventType);
    }
    if (payload?.durationTime) {
      queryString.append("DurationTime", payload.durationTime);
    }

    const query = queryString.toString();

    let endpoint;
    let isFileDownload = false;
    if (download && payload?.fileType) {
      const normalizedFileType = normalizeTypeReportForApi(payload.fileType);
      isFileDownload =
        normalizedFileType === "pdf" || normalizedFileType === "xls";
      endpoint =
        normalizedFileType === "pdf"
          ? `${reportBasePath}/visit-vehicle-summaries/pdf`
          : normalizedFileType === "xls"
            ? `${reportBasePath}/visit-vehicle-summaries/xls`
            : `${reportBasePath}/visit-vehicle-summaries`;
    } else {
      endpoint = `${reportBasePath}/visit-vehicle-summaries`;
    }

    const response = await api.get(
      `${endpoint}${query ? `?${query}` : ""}`,
      isFileDownload ? { responseType: "blob" } : undefined,
    );

    console.log("VisitsAmountReport", response);

    if (isFileDownload) {
      return response?.data ?? null;
    }

    let treated = errorHandling.handleResponse(
      response,
      "reportService.fetchVisitsAmount",
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "reportService.fetchVisitsAmount");
    return null;
  }
}

async function fetchVehicleProtocols(payload, download) {
  try {
    const queryString = new URLSearchParams();
    if (payload?.vehicleId !== undefined && payload?.vehicleId !== null) {
      queryString.append("vehicleId", payload.vehicleId);
    }
    if (payload?.dateTimeScheduleStart) {
      queryString.append("dateOpen", payload.dateTimeScheduleStart);
    }
    if (payload?.dateTimeScheduleEnd) {
      queryString.append("dateClose", payload.dateTimeScheduleEnd);
    }
    queryString.append("pageNumber", `${payload?.pageNumber ?? 1}`);
    queryString.append("pageSize", `${payload?.pageSize ?? 20}`);

    const response = await api.get(
      `${protocolsBasePath}/protocols?${queryString.toString()}`,
    );

    console.log("VehicleProtocolsReport", response);

    let treated = errorHandling.handleResponse(
      response,
      "reportService.fetchVehicleProtocols",
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "reportService.fetchVehicleProtocols");
    return null;
  }
}

/*
async function fetchVehicleProtocolsDetails(protocolId) {
  try {
    const response = await api.get(
      `${reportBasePath}/protocols/${protocolId}/details`,
    );

    console.log("VehicleProtocolsDetailsReport", response);

    let treated = errorHandling.handleResponse(
      response,
      "reportService.fetchVehicleProtocolsDetails",
    );
    if (treated) {
      let protocolDetail = {
        dateTimeOpen: "",
        dateTimeService: "",
        dateTimeClose: "",
        attendant: "",
        status: "",
      };

      if (!Array.isArray(treated) || treated.length === 0) {
        return protocolDetail;
      }

      const detailRegex =
        /^(\d{2}\/\d{2}\/\d{4}\s+\d{2}:\d{2}:\d{2})\s+-\s+(.+)$/;

      treated.forEach((protocol) => {
        if (!protocol?.detail) return;

        const match = protocol.detail.match(detailRegex);
        if (!match) return;

        const [, dateTime, eventType] = match;
        const trimmedEvent = eventType.trim();

        if (trimmedEvent === "Abertura") {
          protocolDetail.dateTimeOpen = dateTime;
        } else if (trimmedEvent === "Alocação do Alerta") {
          protocolDetail.dateTimeService = dateTime;
          protocolDetail.attendant = protocol.userName;
        } else if (trimmedEvent === "Desalocação do Alerta") {
          protocolDetail.dateTimeClose = dateTime;
        }
      });

      if (protocolDetail.dateTimeClose) {
        protocolDetail.status = "FECHADO";
      } else if (protocolDetail.dateTimeService) {
        protocolDetail.status = "EM ATENDIMENTO";
      } else if (protocolDetail.dateTimeOpen) {
        protocolDetail.status = "ABERTO";
      }

      return protocolDetail;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(
      error,
      "reportService.fetchVehicleProtocolsDetails",
    );
    return null;
  }
}
*/

async function fetchSpeedControl(payload, download) {
  try {
    const queryString = new URLSearchParams();
    const normalizedEventType = `${payload?.eventType ?? ""}`.trim();
    const speedValue = `${payload?.speed ?? ""}`.trim();
    const parsedSpeed = Number(speedValue);
    const hasValidSpeed =
      speedValue !== "" && !Number.isNaN(parsedSpeed) && parsedSpeed > 0;

    if (download) {
      if (payload?.groupId !== undefined && payload?.groupId !== null) {
        queryString.append("GroupId", payload.groupId);
      }
      if (payload?.vehicleId !== undefined && payload?.vehicleId !== null) {
        queryString.append("VehicleId", payload.vehicleId);
      }
      if (payload?.dateTimeScheduleStart) {
        queryString.append("StartDate", payload.dateTimeScheduleStart);
      }
      if (payload?.dateTimeScheduleEnd) {
        queryString.append("EndDate", payload.dateTimeScheduleEnd);
      }
      if (hasValidSpeed) {
        queryString.append("Speed", payload.speed);
      }
      if (hasValidSpeed && normalizedEventType) {
        queryString.append("EventType", normalizedEventType);
      }
      if (
        payload?.splitByPlateSheets !== undefined &&
        payload?.splitByPlateSheets !== null
      ) {
        queryString.append("SplitByPlateSheets", payload.splitByPlateSheets);
      }
    } else {
      if (payload?.vehicleId !== undefined && payload?.vehicleId !== null) {
        queryString.append("VehicleId", payload.vehicleId);
      }
      if (payload?.dateTimeScheduleStart) {
        queryString.append("StartDate", payload.dateTimeScheduleStart);
      }
      if (payload?.dateTimeScheduleEnd) {
        queryString.append("EndDate", payload.dateTimeScheduleEnd);
      }
      if (hasValidSpeed) {
        queryString.append("Speed", payload.speed);
      }
      if (hasValidSpeed && normalizedEventType) {
        queryString.append("EventType", normalizedEventType);
      }
    }

    const query = queryString.toString();
    const endpoint = download
      ? `${reportBasePath}/high-speed-summaries/${normalizeTypeReportForApi(payload?.fileType) || "pdf"}`
      : `${reportBasePath}/high-speed-summaries`;

    const response = await api.get(
      `${endpoint}${query ? `?${query}` : ""}`,
      download ? { responseType: "blob" } : undefined,
    );

    console.log("VehicleSpeedControlReport", response);

    if (download) {
      return response?.data ?? null;
    }

    let treated = errorHandling.handleResponse(
      response,
      "reportService.fetchSpeedControl",
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "reportService.fetchSpeedControl");
    return null;
  }
}

async function fetchSummaryMaintenances(filters = {}) {
  try {
    const queryPayload = {
      GroupId: filters.groupId ?? filters.GroupId ?? "",
      VehicleId: filters.vehicleId ?? filters.VehicleId ?? "",
      StartDate: filters.startDate ?? filters.StartDate ?? "",
      EndDate: filters.endDate ?? filters.EndDate ?? "",
      Completed: filters.completed ?? filters.Completed ?? "",
    };

    const query = new URLSearchParams(
      Object.entries(queryPayload).filter(
        ([, v]) => v !== "" && v !== null && v !== undefined,
      ),
    ).toString();

    const url = query
      ? `${reportBasePath}/summary-maintenances?${query}`
      : `${reportBasePath}/summary-maintenances`;
    const response = await api.get(url);

    const treated = errorHandling.handleResponse(
      response,
      "maintenancesService.fetchSummaryMaintenances",
    );
    if (treated) {
      return Array.isArray(treated) ? treated : [treated];
    }
    return null;
  } catch (error) {
    errorHandling.cathError(
      error,
      "maintenancesService.fetchSummaryMaintenances",
    );
    return null;
  }
}

async function fetchSystemLogs(payload, download) {
  try {
    const fileExtension =
      payload.fileType === "pdf"
        ? "pdf"
        : payload.fileType === "xls" || payload.fileType === "xlsx"
          ? "xls"
          : "pdf";

    if (download) {
      const downloadQuery = new URLSearchParams();
      if (payload.dateTimeScheduleStart) {
        downloadQuery.append("StartDate", payload.dateTimeScheduleStart);
      }
      if (payload.dateTimeScheduleEnd) {
        downloadQuery.append("EndDate", payload.dateTimeScheduleEnd);
      }

      if (fileExtension === "pdf") {
        const response = await api.get(
          `${logBasePath}/logs/pdf?${downloadQuery}`,
        );
        const treated = errorHandling.handleResponse(
          response,
          "reportService.fetchSystemLogs.download",
        );
        return treated ?? null;
      }

      const response = await api.get(
        `${logBasePath}/logs/xls?${downloadQuery}`,
      );

      const treated = errorHandling.handleResponse(
        response,
        "reportService.fetchSystemLogs.download",
      );
      return treated ?? null;
    }

    const listQuery = new URLSearchParams();
    listQuery.append("PageSize", payload.pageSize ?? 9999);
    listQuery.append("PageNumber", payload.pageNumber ?? 1);
    if (payload.dateTimeScheduleStart) {
      listQuery.append("StartDate", payload.dateTimeScheduleStart);
    }
    if (payload.dateTimeScheduleEnd) {
      listQuery.append("EndDate", payload.dateTimeScheduleEnd);
    }

    const response = await api.get(`${logBasePath}/logs?${listQuery}`);

    const treated = errorHandling.handleResponse(
      response,
      "reportService.fetchSystemLogs",
    );
    return treated ?? null;
  } catch (error) {
    errorHandling.cathError(error, "reportService.fetchSystemLogs");
    return null;
  }
}

async function fetchVehicleGrid(vehicleId, payload) {
  try {
    const normalizedPayload = normalizeReportPayloadForApi(payload);
    const queryString = new URLSearchParams(normalizedPayload).toString();
    const url = `${reportBasePath}/vehicles/${vehicleId}/reports?${queryString}`;

    let response = await api.get(url);

    let treated = errorHandling.handleResponse(
      response,
      "reportService.fetchVehicleGrid",
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    return null;
  }
}

async function fetchVehicleGridPositions(vehicleId, payload) {
  try {
    const normalizedPayload = normalizeReportPayloadForApi(payload);
    const queryParams = new URLSearchParams(normalizedPayload);
    if (vehicleId !== undefined && vehicleId !== null) {
      queryParams.append("VehicleId", vehicleId);
    }
    const url = `${reportBasePath}/vehicle-positions/positions?${queryParams.toString()}`;

    let response = await api.get(url);

    let treated = errorHandling.handleResponse(
      response,
      "reportService.fetchVehicleGridPositions",
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    return null;
  }
}

async function fetchNearbyVehiclesReport(vehicleId, payload) {
  try {
    const normalizedPayload = normalizeReportPayloadForApi(payload);
    const queryParams = new URLSearchParams(normalizedPayload);
    if (vehicleId !== undefined && vehicleId !== null) {
      queryParams.append("VehicleId", vehicleId);
    }
    const url = `${reportBasePath}/vehicle-proximity?${queryParams.toString()}`;

    let response = await api.get(url);

    let treated = errorHandling.handleResponse(
      response,
      "reportService.fetchNearbyVehicles",
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    return null;
  }
}

// REVISAR ABAIXO
// async function fetchDetailedVehicleActivities(payload, download) {
//   try {
//     let url = `${reportBasePath}/Vehicle/DetailedVehicleActivity`;

//     if (download)
//       url = `${reportBasePath}/Report/GenerateReport/DetailedVehicleActivity/${payload.fileType}`;

//     console.log(url);

//     let response = await api.post(url, payload);

//     let treated = errorHandling.handleResponse(
//       response,
//       'reportService.fetchVehicleActivities'
//     );
//     if (treated) {
//       return treated;
//     }
//     return null;
//   } catch (error) {
//     errorHandling.cathError(error, 'reportService.fetchVehicleActivities');
//     return null;
//   }
// }

async function list(pageSize, pageNumber) {
  try {
    let url = `${reportBasePath}/Report/${pageSize}/${pageNumber}`;

    let response = await api.get(url);

    console.log("SelectJourneyWorkReport", response);

    let treated = errorHandling.handleResponse(
      response,
      "reportService.fetchVehicleActivities",
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "reportService.fetchVehicleActivities");
    return null;
  }
}

async function makeReport(payload) {
  try {
    let url = `${reportBasePath}/Report/makeReportRequest`;

    let response = await api.post(url, payload);

    let treated = errorHandling.handleResponse(
      response,
      "reportService.fetchVehicleActivities",
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "reportService.fetchVehicleActivities");
    return null;
  }
}

async function fetchVehicleGridKML(payload) {
  try {
    const url = `${reportBasePath}/Report/GenerateReport/VehicleGrid/KML`;

    console.log(url);

    let response = await api.post(url, payload);

    console.log("VehicleGridReport", response);

    let treated = errorHandling.handleResponse(
      response,
      "reportService.VehicleGrid",
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "reportService.VehicleGrid");
    return null;
  }
}

// async function fetchVehicleGridPDF(payload) {
// 	try {
// 		const url = `${reportBasePath}/Report/GenerateReport/VehicleGrid/PDF`;

// 		console.log(url);

// 		let response = await api.post(url, payload);

// 		console.log("VehicleGridReport", response);

// 		let treated = errorHandling.handleResponse(
// 			response,
// 			"reportService.VehicleGrid"
// 		);
// 		if (treated) {
// 			return treated;
// 		}
// 		return null;
// 	} catch (error) {
// 		errorHandling.cathError(error, "reportService.VehicleGrid");
// 		return null;
// 	}
// }

async function fetchVehicleGridXLS(payload) {
  try {
    const url = `${reportBasePath}/Report/GenerateReport/VehicleGrid/XLS`;

    console.log(url);

    let response = await api.post(url, payload);

    console.log("VehicleGridReport", response);

    let treated = errorHandling.handleResponse(
      response,
      "reportService.VehicleGrid",
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "reportService.VehicleGrid");
    return null;
  }
}

async function fetchVehiclePositionsXLS(payload) {
  try {
    const url = `${reportBasePath}/Report/GenerateReport/Positions/XLS`;

    console.log(url);

    let response = await api.post(url, payload);

    console.log("Positions", response);

    let treated = errorHandling.handleResponse(
      response,
      "reportService.Positions",
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "reportService.Positions");
    return null;
  }
}

async function fetchVehiclePositionsKML(payload) {
  try {
    const url = `${reportBasePath}/Report/GenerateReport/Positions/KML`;

    console.log(url);

    let response = await api.post(url, payload);

    console.log("Positions", response);

    let treated = errorHandling.handleResponse(
      response,
      "reportService.Positions",
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "reportService.Positions");
    return null;
  }
}

async function fetchVehiclePositionsPDF(payload) {
  try {
    const url = `${reportBasePath}/Report/GenerateReport/Positions/PDF`;

    console.log(url);

    let response = await api.post(url, payload);

    console.log("Positions", response);

    let treated = errorHandling.handleResponse(
      response,
      "reportService.Positions",
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "reportService.Positions");
    return null;
  }
}

async function buildReportVehicles(payload) {
  try {
    const url = `${reportBasePath}/build-reports/vehicle-activity`;

    console.log(url);

    let response = await api.post(url, payload);

    console.log("Positions", response);

    let treated = errorHandling.handleResponse(
      response,
      "reportService.buildReportVehicles",
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "reportService.buildReportVehicles");
    return null;
  }
}

async function addBuildReportVehicles(payload) {
  try {
    const url = `${reportBasePath}/build-reports/vehicle-activity/add`;

    console.log(url);

    let response = await api.post(url, payload);

    console.log("Positions", response);

    let treated = errorHandling.handleResponse(
      response,
      "reportService.addBuildReportVehicles",
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "reportService.addBuildReportVehicles");
    return null;
  }
}

async function addReportVehicles(payload) {
  try {
    const url = `${reportBasePath}/build-reports/vehicle-activity/vehicles`;

    console.log(url);

    let response = await api.post(url, payload);

    console.log("Positions", response);

    let treated = errorHandling.handleResponse(
      response,
      "reportService.addReportVehicles",
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "reportService.addReportVehicles");
    return null;
  }
}

async function addReportVehiclesDate(idReport) {
  try {
    const url = `${reportBasePath}/build-reports/vehicle-activity/personal`;

    console.log(url);

    let response = await api.post(url, idReport);

    console.log("Positions", response);

    let treated = errorHandling.handleResponse(
      response,
      "reportService.addReportVehiclesDate",
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "reportService.addReportVehiclesDate");
    return null;
  }
}

async function vehiclesActivityDownload(typeReport, reportId, groupPlate) {
  try {
    const normalizedTypeReport = normalizeTypeReportForApi(typeReport);
    let url = `${reportBasePath}/build-reports/vehicle-activity?typeReport=${normalizedTypeReport}&reportId=${reportId}&groupPlate=${groupPlate}`;

    let response = await api.get(url);

    console.log("SelectJourneyWorkReport", response);

    let treated = errorHandling.handleResponse(
      response,
      "reportService.vehiclesActivityDownload",
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "reportService.vehiclesActivityDownload");
    return null;
  }
}

async function fetchVehiclesPositionsPdf(payload = {}) {
  try {
    const queryString = new URLSearchParams();

    const vehicleId = payload.vehicleId ?? payload.VehicleId;
    const groupId = payload.groupId ?? payload.GroupId;
    const startDate = payload.startDate ?? payload.StartDate;
    const endDate = payload.endDate ?? payload.EndDate;
    const onlyEvents = payload.onlyEvents ?? payload.OnlyEvents ?? "N";
    const splitByPlateSheets =
      payload.splitByPlateSheets ?? payload.SplitByPlateSheets;

    if (vehicleId) queryString.append("VehicleId", vehicleId);
    if (groupId) queryString.append("GroupId", groupId);
    if (startDate) queryString.append("StartDate", startDate);
    if (endDate) queryString.append("EndDate", endDate);

    queryString.append("OnlyEvents", onlyEvents);

    if (splitByPlateSheets !== undefined && splitByPlateSheets !== null) {
      queryString.append("SplitByPlateSheets", splitByPlateSheets);
    }

    const response = await api.get(
      `${reportBasePath}/vehicle-positions/pdf?${queryString.toString()}`,
      { responseType: "blob" },
    );

    return response?.data ?? null;
  } catch (error) {
    if (error?.response?.status === 404) {
      return {
        error: true,
        status: 404,
        message: "Arquivo não encontrado ou vazio.",
      };
    }

    errorHandling.cathError(error, "reportService.fetchVehiclesPositionsPdf");
    return null;
  }
}

async function fetchVehiclesPositionsPdfExternal(payload = {}) {
  try {
    const queryString = new URLSearchParams();

    const key = payload.key ?? payload.Key;
    const regionalId = payload.regionalId ?? payload.RegionalId;
    const clientId = payload.clientId ?? payload.ClientId;
    const userId = payload.userId ?? payload.UserId;
    const vehicleId = payload.vehicleId ?? payload.VehicleId;
    const groupId = payload.groupId ?? payload.GroupId;
    const startDate = payload.startDate ?? payload.StartDate;
    const endDate = payload.endDate ?? payload.EndDate;
    const onlyEvents = payload.onlyEvents ?? payload.OnlyEvents ?? "N";
    const splitByPlateSheets =
      payload.splitByPlateSheets ?? payload.SplitByPlateSheets;

    if (key !== undefined && key !== null && key !== "") {
      queryString.append("Key", key);
    }

    if (regionalId !== undefined && regionalId !== null && regionalId !== "") {
      queryString.append("RegionalId", regionalId);
    }

    if (clientId !== undefined && clientId !== null && clientId !== "") {
      queryString.append("ClientId", clientId);
    }

    if (userId !== undefined && userId !== null && userId !== "") {
      queryString.append("UserId", userId);
    }

    if (vehicleId) queryString.append("VehicleId", vehicleId);
    if (groupId) queryString.append("GroupId", groupId);
    if (startDate) queryString.append("StartDate", startDate);
    if (endDate) queryString.append("EndDate", endDate);

    queryString.append("OnlyEvents", onlyEvents);

    if (splitByPlateSheets !== undefined && splitByPlateSheets !== null) {
      queryString.append("SplitByPlateSheets", splitByPlateSheets);
    }

    const response = await api.get(
      `${reportBasePath}/vehicle-positions/pdf/external?${queryString.toString()}`,
      { responseType: "blob" },
    );

    return response?.data ?? null;
  } catch (error) {
    if (error?.response?.status === 404) {
      return {
        error: true,
        status: 404,
        message: "Arquivo não encontrado ou vazio.",
      };
    }

    errorHandling.cathError(
      error,
      "reportService.fetchVehiclesPositionsPdfExternal",
    );
    return null;
  }
}

async function fetchVehiclesPositionsXls(payload = {}) {
  try {
    const queryString = new URLSearchParams();

    const vehicleId = payload.vehicleId ?? payload.VehicleId;
    const groupId = payload.groupId ?? payload.GroupId;
    const startDate = payload.startDate ?? payload.StartDate;
    const endDate = payload.endDate ?? payload.EndDate;
    const onlyEvents = payload.onlyEvents ?? payload.OnlyEvents ?? "N";
    const splitByPlateSheets =
      payload.splitByPlateSheets ?? payload.SplitByPlateSheets;

    if (vehicleId) queryString.append("VehicleId", vehicleId);
    if (groupId) queryString.append("GroupId", groupId);
    if (startDate) queryString.append("StartDate", startDate);
    if (endDate) queryString.append("EndDate", endDate);

    queryString.append("OnlyEvents", onlyEvents);

    if (splitByPlateSheets !== undefined && splitByPlateSheets !== null) {
      queryString.append("SplitByPlateSheets", splitByPlateSheets);
    }

    const response = await api.get(
      `${reportBasePath}/vehicle-positions/xls?${queryString.toString()}`,
      { responseType: "blob" },
    );

    return response?.data ?? null;
  } catch (error) {
    if (error?.response?.status === 404) {
      return {
        error: true,
        status: 404,
        message: "Arquivo não encontrado ou vazio.",
      };
    }

    errorHandling.cathError(error, "reportService.fetchVehiclesPositionsXls");
    return null;
  }
}

async function fetchVehiclesPositionsXlsExternal(payload = {}) {
  try {
    const queryString = new URLSearchParams();

    const key = payload.key ?? payload.Key;
    const regionalId = payload.regionalId ?? payload.RegionalId;
    const clientId = payload.clientId ?? payload.ClientId;
    const userId = payload.userId ?? payload.UserId;
    const vehicleId = payload.vehicleId ?? payload.VehicleId;
    const groupId = payload.groupId ?? payload.GroupId;
    const startDate = payload.startDate ?? payload.StartDate;
    const endDate = payload.endDate ?? payload.EndDate;
    const onlyEvents = payload.onlyEvents ?? payload.OnlyEvents ?? "N";
    const splitByPlateSheets =
      payload.splitByPlateSheets ?? payload.SplitByPlateSheets;

    if (key !== undefined && key !== null && key !== "") {
      queryString.append("Key", key);
    }

    if (regionalId !== undefined && regionalId !== null && regionalId !== "") {
      queryString.append("RegionalId", regionalId);
    }

    if (clientId !== undefined && clientId !== null && clientId !== "") {
      queryString.append("ClientId", clientId);
    }

    if (userId !== undefined && userId !== null && userId !== "") {
      queryString.append("UserId", userId);
    }

    if (vehicleId) queryString.append("VehicleId", vehicleId);
    if (groupId) queryString.append("GroupId", groupId);
    if (startDate) queryString.append("StartDate", startDate);
    if (endDate) queryString.append("EndDate", endDate);

    queryString.append("OnlyEvents", onlyEvents);

    if (splitByPlateSheets !== undefined && splitByPlateSheets !== null) {
      queryString.append("SplitByPlateSheets", splitByPlateSheets);
    }

    const response = await api.get(
      `${reportBasePath}/vehicle-positions/xls/external?${queryString.toString()}`,
      { responseType: "blob" },
    );

    return response?.data ?? null;
  } catch (error) {
    if (error?.response?.status === 404) {
      return {
        error: true,
        status: 404,
        message: "Arquivo não encontrado ou vazio.",
      };
    }

    errorHandling.cathError(
      error,
      "reportService.fetchVehiclesPositionsXlsExternal",
    );
    return null;
  }
}

async function fetchVehiclesPositionsKmz(payload = {}) {
  try {
    const queryString = new URLSearchParams();

    const vehicleId = payload.vehicleId ?? payload.VehicleId;
    const groupId = payload.groupId ?? payload.GroupId;
    const startDate = payload.startDate ?? payload.StartDate;
    const endDate = payload.endDate ?? payload.EndDate;
    const onlyEvents = payload.onlyEvents ?? payload.OnlyEvents ?? "N";

    if (vehicleId) queryString.append("VehicleId", vehicleId);
    if (groupId) queryString.append("GroupId", groupId);
    if (startDate) queryString.append("StartDate", startDate);
    if (endDate) queryString.append("EndDate", endDate);

    queryString.append("OnlyEvents", onlyEvents);

    const response = await api.get(
      `${reportBasePath}/vehicle-positions/kmz?${queryString.toString()}`,
      { responseType: "blob" },
    );

    return response?.data ?? null;
  } catch (error) {
    if (error?.response?.status === 404) {
      return {
        error: true,
        status: 404,
        message: "Arquivo não encontrado ou vazio.",
      };
    }

    errorHandling.cathError(error, "reportService.fetchVehiclesPositionsKmz");
    return null;
  }
}

async function fetchVehiclesPositionsKmzExternal(payload = {}) {
  try {
    const queryString = new URLSearchParams();

    const key = payload.key ?? payload.Key;
    const regionalId = payload.regionalId ?? payload.RegionalId;
    const clientId = payload.clientId ?? payload.ClientId;
    const userId = payload.userId ?? payload.UserId;
    const vehicleId = payload.vehicleId ?? payload.VehicleId;
    const groupId = payload.groupId ?? payload.GroupId;
    const startDate = payload.startDate ?? payload.StartDate;
    const endDate = payload.endDate ?? payload.EndDate;
    const onlyEvents = payload.onlyEvents ?? payload.OnlyEvents ?? "N";

    if (key !== undefined && key !== null && key !== "") {
      queryString.append("Key", key);
    }

    if (regionalId !== undefined && regionalId !== null && regionalId !== "") {
      queryString.append("RegionalId", regionalId);
    }

    if (clientId !== undefined && clientId !== null && clientId !== "") {
      queryString.append("ClientId", clientId);
    }

    if (userId !== undefined && userId !== null && userId !== "") {
      queryString.append("UserId", userId);
    }

    if (vehicleId) queryString.append("VehicleId", vehicleId);
    if (groupId) queryString.append("GroupId", groupId);
    if (startDate) queryString.append("StartDate", startDate);
    if (endDate) queryString.append("EndDate", endDate);

    queryString.append("OnlyEvents", onlyEvents);

    const response = await api.get(
      `${reportBasePath}/vehicle-positions/kmz/external?${queryString.toString()}`,
      { responseType: "blob" },
    );

    return response?.data ?? null;
  } catch (error) {
    if (error?.response?.status === 404) {
      return {
        error: true,
        status: 404,
        message: "Arquivo não encontrado ou vazio.",
      };
    }

    errorHandling.cathError(
      error,
      "reportService.fetchVehiclesPositionsKmzExternal",
    );
    return null;
  }
}

async function fetchVehiclesPositionsPaged(payload = {}) {
  try {
    const queryString = new URLSearchParams();

    const vehicleId = payload.vehicleId ?? payload.VehicleId;
    const groupId = payload.groupId ?? payload.GroupId;
    const startDate = payload.startDate ?? payload.StartDate;
    const endDate = payload.endDate ?? payload.EndDate;
    const onlyEvents = payload.onlyEvents ?? payload.OnlyEvents;
    const pageNumber = payload.pageNumber ?? payload.PageNumber;
    const pageSize = payload.pageSize ?? payload.PageSize;

    if (vehicleId) queryString.append("VehicleId", vehicleId);
    if (groupId) queryString.append("GroupId", groupId);
    if (startDate) queryString.append("StartDate", startDate);
    if (endDate) queryString.append("EndDate", endDate);

    const normalizedOnlyEvents = `${onlyEvents ?? ""}`.trim().toUpperCase();

    if (normalizedOnlyEvents && normalizedOnlyEvents !== "N") {
      queryString.append("OnlyEvents", onlyEvents);
    }
    if (pageNumber !== undefined && pageNumber !== null) {
      queryString.append("PageNumber", pageNumber);
    }
    if (pageSize !== undefined && pageSize !== null) {
      queryString.append("PageSize", pageSize);
    }

    const response = await api.get(
      `${reportBasePath}/vehicle-positions/positions?${queryString.toString()}`,
    );

    const treated = errorHandling.handleResponse(
      response,
      "reportService.fetchVehiclesPositionsPaged",
    );

    if (treated) {
      return treated;
    }

    return null;
  } catch (error) {
    if (error?.response?.status === 404) {
      return {
        error: true,
        status: 404,
        message: "Arquivo não encontrado ou vazio.",
      };
    }

    errorHandling.cathError(error, "reportService.fetchVehiclesPositionsPaged");
    return null;
  }
}

async function fetchSummaryMaintenancesPdf(filters = {}) {
  try {
    const queryPayload = {
      GroupId: filters.groupId ?? filters.GroupId ?? "",
      VehicleId: filters.vehicleId ?? filters.VehicleId ?? "",
      StartDate: filters.startDate ?? filters.StartDate ?? "",
      EndDate: filters.endDate ?? filters.EndDate ?? "",
      Completed: filters.completed ?? filters.Completed ?? "",
      SplitByPlateSheets:
        filters.splitByPlateSheets ?? filters.SplitByPlateSheets ?? "",
    };

    const query = new URLSearchParams(
      Object.entries(queryPayload).filter(
        ([, v]) => v !== "" && v !== null && v !== undefined,
      ),
    ).toString();

    const url = `${reportBasePath}/summary-maintenances/pdf${query ? `?${query}` : ""}`;
    const response = await api.get(url, { responseType: "blob" });

    return response?.data ?? null;
  } catch (error) {
    errorHandling.cathError(error, "reportService.fetchSummaryMaintenancesPdf");
    return null;
  }
}

async function fetchSummaryMaintenancesXls(filters = {}) {
  try {
    const queryPayload = {
      GroupId: filters.groupId ?? filters.GroupId ?? "",
      VehicleId: filters.vehicleId ?? filters.VehicleId ?? "",
      StartDate: filters.startDate ?? filters.StartDate ?? "",
      EndDate: filters.endDate ?? filters.EndDate ?? "",
      Completed: filters.completed ?? filters.Completed ?? "",
      SplitByPlateSheets:
        filters.splitByPlateSheets ?? filters.SplitByPlateSheets ?? "",
    };

    const query = new URLSearchParams(
      Object.entries(queryPayload).filter(
        ([, v]) => v !== "" && v !== null && v !== undefined,
      ),
    ).toString();

    const url = `${reportBasePath}/summary-maintenances/xls${query ? `?${query}` : ""}`;
    const response = await api.get(url, { responseType: "blob" });

    return response?.data ?? null;
  } catch (error) {
    errorHandling.cathError(error, "reportService.fetchSummaryMaintenancesXls");
    return null;
  }
}

export const reportService = {
  fetchJourneyWork,
  fetchDistanceTravelled,
  fetchVehicleActivities,
  fetchVehiclePositions,
  fetchVisitsInPeriod,
  fetchVisitsAmount,
  fetchVehicleProtocols,
  fetchSpeedControl,
  fetchSystemLogs,
  fetchVehicleGrid,
  fetchVehicleGridPositions,
  fetchNearbyVehiclesReport,
  // Revisar abaixo
  fetchVehicleGridKML,
  fetchVehicleGridXLS,
  fetchVehiclePositionsXLS,
  fetchVehiclePositionsKML,
  fetchVehiclePositionsPDF,
  // fetchDetailedVehicleActivities,
  list,
  makeReport,
  buildReportVehicles,
  addBuildReportVehicles,
  addReportVehicles,
  addReportVehiclesDate,
  vehiclesActivityDownload,
  fetchVehiclesPositionsPdf,
  fetchVehiclesPositionsPdfExternal,
  fetchVehiclesPositionsXls,
  fetchVehiclesPositionsXlsExternal,
  fetchVehiclesPositionsKmz,
  fetchVehiclesPositionsKmzExternal,
  fetchVehiclesPositionsPaged,
  fetchSummaryMaintenances,
  fetchSummaryMaintenancesPdf,
  fetchSummaryMaintenancesXls,
};
